module.exports = __webpack_public_path__ + "img/pattern3.381b51d.svg";